export default {
  model: [
    {
      label: 'Nome',
      field: 'name',
      type: 'text'
    },
    {
      label: 'E-mail',
      field: 'email',
      type: 'email'
    },
    {
      label: 'Tipos de notificação',
      field: 'notificationTypes',
      type: 'array'
    }
  ]
}